import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ProductType } from '../../models/dbmodels';
import { IStateService, StateService } from '../state.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductTypesService extends StateService<ProductType> implements IStateService<ProductType> {
  apiUrl: string = environment.apiUrls.productTypes;

  public override getAll() {
    return this.get();
  }

  public override getMany(): Observable<ProductType[]> {
    throw new Error('Method not implemented.');
  }

  public override getOne(): Observable<ProductType> {
    throw new Error('Method not implemented.');
  }

  public override getOneById(id: number): Observable<ProductType> {
    throw new Error('Method not implemented.');
  }

  public override postOne(data: ProductType): Observable<ProductType> {
    throw new Error('Method not implemented.');
  }

  public override postMany(data: ProductType[]): Observable<ProductType[]> {
    throw new Error('Method not implemented.');
  }

  public override patchOne(data: ProductType): Observable<ProductType> {
    throw new Error('Method not implemented.');
  }

  public override patchMany(data: ProductType[]): Observable<ProductType[]> {
    throw new Error('Method not implemented.');
  }

  public override putOne(data: ProductType): Observable<ProductType> {
    throw new Error('Method not implemented.');
  }

  public override putMany(data: ProductType[]): Observable<ProductType[]> {
    throw new Error('Method not implemented.');
  }

  public override deleteOne(data: ProductType): Observable<ProductType> {
    throw new Error('Method not implemented.');
  }

  public override deleteMany(data: ProductType[]): Observable<ProductType[]> {
    throw new Error('Method not implemented.');
  }

  public override getAllAsync(): Promise<ProductType[]> {
    throw new Error('Method not implemented.');
  }

  public override getManyAsync(): Promise<ProductType[]> {
    throw new Error('Method not implemented.');
  }

  public override getOneAsync(): Promise<ProductType> {
    throw new Error('Method not implemented.');
  }

  public override getOneByIdAsync(id: number): Promise<ProductType> {
    throw new Error('Method not implemented.');
  }

  public override postOneAsync(data: ProductType): Promise<ProductType> {
    throw new Error('Method not implemented.');
  }

  public override postManyAsync(data: ProductType[]): Promise<ProductType[]> {
    throw new Error('Method not implemented.');
  }

  public override patchOneAsync(data: ProductType): Promise<ProductType> {
    throw new Error('Method not implemented.');
  }

  public override patchManyAsync(data: ProductType[]): Promise<ProductType[]> {
    throw new Error('Method not implemented.');
  }

  public override putOneAsync(data: ProductType): Promise<ProductType> {
    throw new Error('Method not implemented.');
  }

  public override putManyAsync(data: ProductType[]): Promise<ProductType[]> {
    throw new Error('Method not implemented.');
  }

  public override deleteOneAsync(data: ProductType): Promise<ProductType> {
    throw new Error('Method not implemented.');
  }

  public override deleteManyAsync(data: ProductType[]): Promise<ProductType[]> {
    throw new Error('Method not implemented.');
  }


}
